import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import ContentSection from "core/Components/ContentSection";

type Props = {
    children: React.ReactNode
};

const TextContainer: React.FC<Props> = ({ children }) => {
    const theme: Theme = useTheme();

    const containerStyle = css`
        width: 100%;
        display: block;
        column-gap: 2%;

        ${theme.breakpoints.up("md")} {
            column-count: 2;
        }
    `;

    return (
        <ContentSection css={containerStyle} alignItems={"start"}>
            {children}
        </ContentSection>
    );
}

export default TextContainer;
